import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes';
import ScrollToTop from './scripts/scrollToTop';
import './css/main.css';

const loadFonts = (): void => {
  const link: HTMLLinkElement = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&family=Lato:ital,wght@0,100;0,300;0,400;1,100;1,300;1,400&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap';
  document.head.appendChild(link);
};




const App: React.FC = () => {


  useEffect(() => {
    loadFonts();
  }, []);



  return (
    <Router>
      <ScrollToTop/>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;